import classNames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { ActivityHelper } from '../../helpers/ActivityHelper';
import { ERouterPath } from '../router/ERouterPath';
import './InactiveScreen.scss';

export const InactiveScreen = (): JSX.Element => {
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [inactiveSince, setInactiveSince] = useState<Date|null>(null);
  const timeBeforeLogout = 900_000; // 900_000ms = 15 minutes

  const logoutOnTimeout = useCallback(() => {
    if (!inactiveSince) {
      return;
    }

    const logoutAt = inactiveSince.getTime() + timeBeforeLogout;
    const now = new Date().getTime();
    const shouldLogout = logoutAt < now;
    if (shouldLogout) {
      history.push(ERouterPath.logout);
    }
  }, [inactiveSince]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const isInactive = ActivityHelper.isInactive();
      const currentlyShowingInactiveScreen = show;

      if (isInactive && !currentlyShowingInactiveScreen) {
        setShow(true);
        setInactiveSince(new Date());
      } else if (!isInactive && currentlyShowingInactiveScreen) {
        setShow(false);
        setInactiveSince(null);
      }

      logoutOnTimeout();
    }, 300);

    return () => clearInterval(intervalId);
  }, [show, logoutOnTimeout]);

  return <div className={classNames('inactive-screen', { 'inactive-screen--show': show })}>
    <Alert variant="info" className="inactive-screen__info">Je bent inactief. Als je inactief blijft wordt je uitgelogd.</Alert>
  </div>;
};
